import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { NumberDisplay } from "@opensea/ui-kit";
import { ActivityQuantityFragment } from "./ActivityQuantity.fragment";
export function ActivityQuantity(t0) {
  const $ = _c(4);
  const {
    activity: activityKey
  } = t0;
  let t1;
  if ($[0] !== activityKey) {
    t1 = readFragment(ActivityQuantityFragment, activityKey);
    $[0] = activityKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activity = t1;
  let t2;
  if ($[2] !== activity.quantity) {
    t2 = <NumberDisplay display="full" value={activity.quantity} />;
    $[2] = activity.quantity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}